<template>
  <div class="bg-surface-canvas dark:bg-surface-level-900">
    <NavigationCheckout />

    <slot />

    <Footer />
  </div>
</template>
